<ng-container *ngIf="activity.status == 'Closed' && environment.clientId == 'rubbl.website'">
  <div class="alert alert-success" role="alert" *ngIf="activity.activityResponse == 'true' || activity.metadata.activityResponse == 'true'">
    Thank you for completing the machine availability check. Once the renter is verified, you will receive an order confirmation.
  </div>
</ng-container>
<common-activity-type-base [activity]="activity">
  <div class="w-50 mt-5 mx-auto" *ngIf="!loaded">
    <common-spinner-loader></common-spinner-loader>
  </div>
  <div *ngIf="loaded">
    <img class="img-fluid br-5" [src]="baseImagePath + rentalRequestItem.imageThumbnail" />

    <div class="teko fs-30" style="font-weight: 500">
      {{ rentalRequestItem.inventoryItemSummary.year }} {{ rentalRequestItem.inventoryItemSummary.make }} {{ rentalRequestItem.inventoryItemSummary.model }}
    </div>

    <dl class="row">
      <dt class="col-sm-3 font-weight-bold">Serial Number</dt>
      <dd class="col-sm-9">{{ rentalRequestItem.inventoryItemSummary.serialNumber }}</dd>
      <ng-container *ngIf="rentalRequestItem.relatedItems?.length">
        <dt class="col-sm-3 font-weight-bold">Attachments</dt>
        <dd class="col-sm-9">
          <div *ngFor="let attachment of rentalRequestItem.relatedItems">
            {{ attachment.title }} <span *ngIf="attachment.inventoryItemSummary.serialNumber">(SN: {{ attachment.inventoryItemSummary.serialNumber }})</span>
          </div>
        </dd>
      </ng-container>

      <dt class="col-sm-3 font-weight-bold">Machine Location</dt>
      <dd class="col-sm-9">{{ rentalRequestItem.inventoryItemSummary.locationSummary }}</dd>

      <dt class="col-sm-3 font-weight-bold">Rental Rate</dt>
      <dd class="col-sm-9">{{ rentalRate | currency }}/{{ rentalTerm }}</dd>

      <ng-container *ngIf="rentalRequestItem.relatedItems?.length">
        <dt class="col-sm-3 font-weight-bold">Attachments Rental Rate</dt>
        <dd class="col-sm-9">{{ attachmentRentalRate | currency }}/{{ rentalTerm }}</dd>
      </ng-container>

      <dt class="col-sm-3 font-weight-bold">Earnings</dt>
      <dd class="col-sm-9">{{ netEarnings | currency }}/{{ rentalTerm }}</dd>
      <!-- <dt class="col-sm-3 font-weight-bold">Total Earnings</dt>
      <dd class="col-sm-9">
        {{ totalNetEarnings | currency }}
      </dd> -->

      <dt class="col-sm-3 font-weight-bold">Job Duration</dt>
      <dd class="col-sm-9">{{ rentalRequestItem.startDate | date: "mediumDate" }} - {{ rentalRequestItem.endDate | date: "mediumDate" }}</dd>

      <dt class="col-sm-3 font-weight-bold">Job Location</dt>
      <dd class="col-sm-9">{{ rentalRequest.transportationInfo.deliveryAddress.address | address: "cityState" }} ({{ milesAway | number }} miles away)</dd>
    </dl>
    <ng-container *ngIf="activity.status == 'Open'">
      <div class="mt-3">
        <h4>Is this machine available?</h4>
        <div class="form-group d-flex">
          <div class="form-check form-check-inline radio-button">
            <common-radio-button
              id="machineAvailableYes"
              groupName="machineAvailable"
              label="Yes"
              [value]="true"
              (modelChange)="machineAvailableChange($event)"
              [(model)]="available"
            >
            </common-radio-button>
          </div>
          <div class="form-check form-check-inline radio-button">
            <common-radio-button
              id="machineAvailableNo"
              groupName="machineAvailable"
              label="No"
              [value]="false"
              (modelChange)="machineAvailableChange($event)"
              [(model)]="available"
            >
            </common-radio-button>
          </div>
        </div>
      </div>
      <ng-container *ngIf="available">
        <div class="mt-3">
          <p class="fs-18">Would you like to transport your equipment? <span class="text-success">We will pay you!</span></p>
          <div class="form-group d-flex">
            <div class="form-check form-check-inline radio-button">
              <common-radio-button id="provideTranspoYes" groupName="provideTranspo" label="Yes" [value]="true" [(model)]="canProvideTransport">
              </common-radio-button>
            </div>
            <div class="form-check form-check-inline radio-button">
              <common-radio-button id="provideTranspoNo" groupName="provideTranspo" label="No" [value]="false" [(model)]="canProvideTransport">
              </common-radio-button>
            </div>
          </div>
          <div class="form-group" *ngIf="canProvideTransport">
            <label class="fs-18" for="transpoQuote">Enter <span class="text-success">round-trip</span> transportation quote</label>
            <div class="input-group mb-2 w-50">
              <div class="input-group-prepend">
                <div class="input-group-text">$</div>
              </div>
              <input type="number" class="form-control" [(ngModel)]="transpoQuote" name="transpoQuote" />
            </div>
          </div>
        </div>
        <p class="fs-18">Please review and accept our rental terms.</p>
        <div class="form-group mt-3" *ngFor="let term of terms">
          <div class="d-flex align-items-center mr-5">
            <app-input-checkbox [label]="term.label" [(checked)]="term.checked" [large]="true" [invalid]="false" [useHtml]="true"> </app-input-checkbox>
            <app-questionmark-tooltip *ngIf="term.tooltip" class="ml-2" [displayLearnMore]="false" [text]="term.tooltip" mobilePlacement="left">
            </app-questionmark-tooltip>
          </div>
        </div>

        <p class="fs-18">Sign below to accept your rental terms.</p>
        <div class="mb-3 w-100">
          <canvas #canvas height="220px;"></canvas>
        </div>
      </ng-container>

      <ng-container *ngIf="available == false">
        <div class="form-group">
          <h4>Reason</h4>
          <select class="form-control" (change)="notAvailableReasonSelected($event.target.value)">
            <option disabled="disabled" selected="selected" default>Select</option>
            <option>Currently in operation</option>
            <option>Job duration too long</option>
            <option>Job start date too early</option>
            <option>Jobsite too far</option>
            <option>Mechanical breakdown</option>
            <option>Sold machine</option>
          </select>
        </div>
      </ng-container>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-success btn-block btn-modal-footer" (click)="save()" [disabled]="disableButton">Submit</button>
      </div>
      <div class="alert alert-warning my-3" role="alert" *ngIf="environment.clientId == 'rubbl.admin'">
        <div>Rubbl Admin can not submit machine availability check. Owner of the machine needs to submit it.</div>
      </div>
    </ng-container>
    <ng-container *ngIf="activity.status == 'Closed'">
      <div class="fs-18">Is the machine available?</div>
      <div class="font-weight-light">{{ activity.activityResponse == "true" ? "Yes" : "No" }}</div>

      <ng-container *ngIf="activity.metadata.activityResponse == 'true' || activity.activityResponse == 'true'; else failureReason">
        <div class="fs-18 mt-3">Do you want to provide transportation?</div>
        <div class="font-weight-light">{{ activity.metadata.canProvideTransport == "true" ? "Yes" : "No" }}</div>

        <ng-container *ngIf="activity.metadata.transportQuote != null">
          <div class="fs-18 mt-3">Transportation Quote</div>
          <div class="font-weight-light">{{ activity.metadata.transportQuote | currency: "USD":"symbol":"1.0-0" }}</div>
        </ng-container>

        <div class="fs-18 mt-3">Terms Accepted</div>
        <div class="font-weight-light mb-3" *ngFor="let term of activity.metadata.terms" [innerHtml]="term.label"></div>

        <div class="fs-18 mt-3">Signature</div>
        <img class="img-fluid" [src]="activity.metadata.signatureDataUrl" />
      </ng-container>

      <ng-template #failureReason>
        <div class="fs-18 mt-3">Reason</div>
        <div class="font-weight-light">{{ activity.metadata.notAvailableReason }}</div>
      </ng-template>
    </ng-container>
  </div>
</common-activity-type-base>
